/**
 * Observe changes in the DOM of a specified element.
 *
 * @param {Element} obj - The DOM element to observe for changes.
 * @param {boolean} withMutations - A flag to control detailed mutation information.
 * @param {MutationObserverInit} [observerOptions] - Options for the MutationObserver.
 * @param {function} callback - The function to call when DOM changes occur.
 */
window.observeDOM = (function () {
    let MutationObserver = window.MutationObserver || window.WebKitMutationObserver,
        eventListenerSupported = window.addEventListener;

    return function (obj, withMutations, observerOptions, callback) {
        if (MutationObserver) {
            let obs = new MutationObserver(function (mutations) {
                if (withMutations) {
                    callback(mutations);
                } else {
                    if (mutations[0].addedNodes.length || mutations[0].removedNodes.length) callback();
                }
            });
            let options = observerOptions || {
                childList: true,
                subtree: true,
                attributes: true,
            };
            if (obj) {
                obs.observe(obj, options);
            }
        } else if (eventListenerSupported) {
            obj.addEventListener('DOMNodeInserted', callback, false);
            obj.addEventListener('DOMNodeRemoved', callback, false);
        }
    };
})();
